import ProjectCalculations from 'components/project-calculations'
import { appliesMeta } from '@/utils/functions/applies-meta'

export default appliesMeta({
    requiresAuth: true,
    template: 'chameleon'
  },
  [
    {
      path: '/project-calculations',
      component: ProjectCalculations.ProjectCalculationList,
      name: 'project-calculations.index',
    },
    {
      path: '/project-calculations/create',
      component: ProjectCalculations.ProjectCalculationForm,
      name: 'project-calculations.create',
    },
    {
      path: '/project-calculations/:projectCalculationId/edit',
      component: ProjectCalculations.ProjectCalculationForm,
      name: 'project-calculations.edit',
      props: true,
    },
  ])
